module.exports = __webpack_public_path__ + "img/cliprate_text_logo.6d7ac0c3.svg";